import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: 'office/score/save',
    data: from,
    method: 'post'
})

export const byUid = (from) => axios.request({
    url: 'office/score/byUid',
    data: from,
    method: 'post'
})